import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "center",
    width: 296,
    bottom: 0,
    margin: "15px auto",
    position: "fixed",
    zIndex: 2,
  },
  button: {
    fontSize: "12px",
  },
}));
